import { Navigate } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { fetchUserOrganization } from "../../Utils/functions";
import { useEffect } from "react";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuthenticator((context) => [context.user]);
  const allowSearch = localStorage.getItem("SearchRemaining") === "1";

  useEffect(() => {
    const saveOrgToLocalStorage = async () => {
      if (user) {
        try {
          const org = await fetchUserOrganization();
          if (org && org.id) {
            localStorage.setItem("organizationId", org.id);
            if (org.name) localStorage.setItem("organizationName", org.name);
          }
        } catch (e) {
          console.error("Error fetching organization:", e);
        }
      }
    };
    saveOrgToLocalStorage();
  }, [user]);

  if (!user && !allowSearch) {
    // User is not authenticated and has no free searches remaining
    const currentPath = window.location.pathname + window.location.search;
    const redirectUrl = `/login?redirect=${encodeURIComponent(currentPath)}`;
    return <Navigate to={redirectUrl} replace />;
  }
  return children;
};

export default ProtectedRoute;
